import { render } from "./Users.vue?vue&type=template&id=0c4653cb&scoped=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=0c4653cb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0c4653cb"

export default script